<template>

  <div class="vflex">

    <creating
      v-if="creating"
      height="100%" />

    <template v-else>
      <div class="vflex-row-0 vflex-header p-3">
        <div class="page-title">
          <div class="title">
            <router-link
              :to="{ name: 'config.integrations' }"
              class="link-discreet mr-2">
              <i class="fa-solid fa-chevron-left"></i>
            </router-link>
            <h4 class="d-inline">{{ title }}</h4>
          </div>
          <div
            v-if="connection"
            class="btn-row">
            <button
              type="button"
              class="btn btn-outline-danger"
              :disabled="loading"
              @click="remove()">{{ $t('Remove') }}</button>
          </div>
        </div>
      </div>

      <div class="vflex-row-1 p-3">
        <div
          class="shurt-conatiner"
          :class="{'box-loading': loading}">

          <div class="mb-3" v-if="subtitle">
            <b>Identificador:</b> {{ subtitle }}
          </div>

          <!--status da conexão-->
          <ul
            v-if="connection"
            class="list-group mb-4">
            <li class="list-group-item d-flex justify-content-between align-items-center">
              <span>{{ $t('Status') }}</span>
              <span
                class="badge"
                :class="active ? 'badge-success' : 'badge-secondary'">
                {{ active ? $t('Connected') : $t('Disconnected') }}
              </span>
            </li>
            <li
              v-if="statusDetail"
              class="list-group-item subtext">
              {{ statusDetail }}
            </li>
          </ul>

          <!--conteúdo do conector (form ou custom)-->
          <component
            v-if="connection"
            :is="pageComponent"
            :connection="connection"
            :integration="integration" />

          <NoResults v-else>{{ $t('There are no items') }}</NoResults>

        </div>
      </div>

    </template>

  </div>

</template>

<script>
import connectors from './connectors'

export default {
  name: 'ConnectionPage',
  data () {
    return {
      creating: true,
      loading: false,
      connection: null
    }
  },
  computed: {
    id () {
      return this.$route.params.id
    },
    integrationName () {
      return this.connection ? this.connection.integration : null
    },
    // descritor da integração, usado pelo conector de formulário (settings.formSchema)
    integration () {
      const integrations = this.$store.getters.getIntegrationProviders || []
      return integrations.find((item) => {
        return item.integration === this.integrationName
      }) || {}
    },
    pageComponent () {
      return connectors.getConnector(this.integration).page
    },
    active () {
      return this.connection ? this.connection.status === 'active' : false
    },
    statusDetail () {
      return this.connection ? (this.connection.status_detail || null) : null
    },
    // título: nome da integração (ex.: Indeed)
    title () {
      if (!this.connection) return this.$t('Connections / Integrations')
      return this.integration.label || this.integrationName
    },
    // subtítulo: o dado da conexão (ex.: email, nome da conta do whatsapp)
    subtitle () {
      if (!this.connection) return null

      const name = this.connection.name || this.connection.provider_unique_id
      if (!name) return null

      // o backend às vezes já devolve o nome prefixado com a integração
      const prefix = this.title + ' - '
      return name.indexOf(prefix) === 0 ? name.slice(prefix.length) : name
    }
  },
  metaInfo () {
    return {
      title: this.title
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    /*
    loadData
    carrega as conexões e as integrações, localizando a conexão pelo id da rota
    */
    loadData () {
      this.creating = true

      Promise.all([
        this.$store.dispatch('selectConnections'),
        this.$store.dispatch('selectIntegrationProviders')
      ])
      .then(([connections]) => {
        this.connection = (connections || []).find((item) => {
          return item._id === this.id
        }) || null
        this.creating = false
      })
      .catch(() => {
        this.creating = false
      })
    },
    /*
    remove
    */
    remove () {
      const deleteAction = () => {
        this.loading = true

        this.$store
        .dispatch('deleteConnection', {
          integration: this.integrationName,
          id: this.connection._id
        })
        .then(() => {
          this.loading = false
          this.$router.push({ name: 'config.integrations' })
        })
        .catch(() => {
          this.loading = false
        })
      }

      this.$store.dispatch('setAlertModal', {
        action: deleteAction
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Integrations/ConnectionPage.vue